






































































































import BaseComponent from '@/core/base.component';
import AuthService from '@/services/shared/auth/auth.service';
import JwtStorageService from '@/services/shared/auth/jwt-storage.service';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { throttleTime } from 'rxjs/operators';
import {
  SigninDto,
  CheckSMSCodeDto,
  RegisterSMSCodeDto,
} from '@/services/shared/auth';

@Component
export default class Login extends BaseComponent {
  private signinDto: SigninDto = new SigninDto();
  private checkSMSCodeDto: CheckSMSCodeDto = new CheckSMSCodeDto();
  private registerSMSCodeDto: RegisterSMSCodeDto = new RegisterSMSCodeDto();
  private codeCorrect = false;
  private codeSent = false;
  private isGetCodeBtnDisabled = false;
  private time = 30;
  private phoneNoLoading = false;
  private authNoLoading = false;
  private passwordLoading = false;
  private clearOut() {
    this.signinDto = new SigninDto();
    this.checkSMSCodeDto = new CheckSMSCodeDto();
    this.registerSMSCodeDto = new RegisterSMSCodeDto();
  }
  public $refs: {
    authNoInput: HTMLElement;
    passwordInput: HTMLElement;
    phoneNoInput: HTMLElement;
  };
  @Watch('registerSMSCodeDto', { deep: true })
  registerDtoChanged() {
    this.checkSMSCodeDto.phone = this.registerSMSCodeDto.phone;
    this.signinDto.phone = this.checkSMSCodeDto.phone;
  }

  // sign in for user
  signIn() {
    this.passwordLoading = true;
    AuthService.signin(this.signinDto).subscribe(res => {
      this.passwordLoading = false;
      if (!res) {
        this.signinDto.password = '';
      } else {
        JwtStorageService.setToken(res.data);
        this.$router.push('/dashboard');
      }
    });
  }
  countDownTimer() {
    if (this.time > 0) {
      setTimeout(() => {
        this.time -= 1;
        this.countDownTimer();
      }, 1000);
    }
  }
  getSMSCode() {
    this.phoneNoLoading = true;
    AuthService.getSMSCode(this.registerSMSCodeDto).subscribe(res => {
      this.phoneNoLoading = false;
      if (res) {
        this.time = 30;
        this.codeSent = true;
        this.isGetCodeBtnDisabled = true;
        setTimeout(() => {
          this.isGetCodeBtnDisabled = false;
        }, this.time * 1000);
        this.countDownTimer();
        this.$nextTick(() => this.$refs.authNoInput.focus());
      }
    });
  }
  checkSMSCode() {
    this.authNoLoading = true;
    AuthService.checkSMSCode(this.checkSMSCodeDto).subscribe(res => {
      this.authNoLoading = false;
      if (res) {
        this.codeCorrect = res.data as boolean;
        this.$nextTick(() => this.$refs.passwordInput.focus());
      } else {
        this.checkSMSCodeDto.authCode = '';
      }
    });
  }
  mounted() {
    // console.log(this.isLoggedIn);
    this.clearOut();
    this.$nextTick(() => {
      this.$refs.phoneNoInput.focus();
    });
  }
}
